document.addEventListener('DOMContentLoaded', function () {
    const widthInput = document.querySelector('.calculator__width-input');
    const heightInput = document.querySelector('.calculator__height-input');
    const spaceCalculationResult = document.querySelector('.calculator__result');

    const productDimensions = productSize.split('x').map((item) => item.trim().replace(',', '.'));
    
    const space = (parseFloat(productDimensions[0]) / 100) * (parseFloat(productDimensions[1]) / 100);
   
    function parseInput(value) {
        if (!value) return NaN;
        value = value.replace(',', '.');
        if (!/^\d*\.?\d*$/.test(value)) return NaN;
        return parseFloat(value);
    }

    function sanitizeInput(input) {
        input.value = input.value.replace(/[^0-9.,]/g, '').replace(',', '.'); 
    }

    function updateResult() {
        sanitizeInput(widthInput);
        sanitizeInput(heightInput);

        const width = parseInput(widthInput.value);
        const height = parseInput(heightInput.value);

        if (!isNaN(width) && !isNaN(height)) {
            const product = width * height;
            const calculatedValue = Math.max(Math.ceil(product / space), 1);

            productUnit[productUnit.length - 2] = calculatedValue.toString();
            spaceCalculationResult.textContent = productUnit.join(' ');
        } else {
            spaceCalculationResult.textContent = '';
        }
    }

    widthInput.addEventListener('input', updateResult);
    heightInput.addEventListener('input', updateResult);
});
